"use client";

import clsx from "clsx";
import { Dashboard } from "@/components/scene/Dashboard";
import { advanceScreen } from "@/lib/presenter/advanceScreen";
import { useTranslations } from "@/lib/compat/i18n";

/**
 * Screen 0.6 — Submit-a-Proposal gate. Behind the modal: ghosted importer
 * dashboard with locked module tiles. CTA: Verify yourself.
 */
export function ProposalGate({ className }: { className?: string }) {
  const t = useTranslations("proposalGate");
  return (
    <div className={clsx("relative flex h-full overflow-hidden rounded-lg border border-state-verified/15", className)}>
      <Dashboard variant="ghost" unlocked={new Set()} />
      <div className="flex-1 bg-orbitra-ink/40 p-5 opacity-50">
        <p className="font-mono text-[9px] uppercase tracking-[0.18em] text-orbitra-teal-soft">{t("pipelineKicker")}</p>
        <h2 className="mt-1 font-display text-lg font-semibold text-orbitra-paper">{t("noActiveTrades")}</h2>
        <div className="mt-4 grid grid-cols-3 gap-3">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="h-20 rounded-md border border-orbitra-muted/20 bg-orbitra-ink/30" />
          ))}
        </div>
      </div>

      <div className="absolute inset-0 z-30 flex items-center justify-center bg-orbitra-ink/65 backdrop-blur-sm">
        <div className="glass w-[460px] p-6 shadow-glass">
          <p className="font-mono text-[9px] uppercase tracking-[0.18em] text-state-verified">{t("verifyKicker")}</p>
          <h2 className="mt-2 font-display text-lg font-semibold text-orbitra-paper">
            {t("verifyTitle")}
          </h2>
          <p className="mt-2 text-[12px] text-orbitra-teal-soft">{t("verifySubtitle")}</p>

          <div className="mt-5 flex items-center justify-between rounded-md border border-state-verified/30 bg-orbitra-ink/60 px-3 py-2 text-[11px]">
            <span className="text-orbitra-muted">{t("invitingParty")}</span>
            <span className="font-mono text-state-verified">{t("invitingPartyValue")}</span>
          </div>

          <button type="button" onClick={advanceScreen} className="cta-primary mt-5 w-full py-2.5 text-[12px]">
            {t("verifyCta")}
          </button>
        </div>
      </div>
    </div>
  );
}
